module.exports = __webpack_public_path__ + "img/chatzotzra_yes.c419bcc9.png";